// extracted by mini-css-extract-plugin
export default {"container":"eC-z","vocBtn":"fC-z","disabled":"gC-z"};